import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { FeatureApi } from '../../api/FeatureApi';
import { updateTableData } from '../../store/utilities/SliceDataHelper';

import type {
  IPaginationRequest,
  IMultiNumericCreateRequest,
  IDeleteRequest,
} from '../../../types/IApiTypes';
import type { IFeatureState } from '../../../types';

const initialState: IFeatureState = {
  multiNumericFeature: {
    data: {},
    totalCount: 0,
    currentPage: 0,
    recordsPerPage: 0,
    searchKey: '',
  },
};

//This action call the fetchMultiNumericFeatures api method to fetch the multi numeric features.
export const fetchMultiNumericFeatures = createAsyncThunk(
  'feature/fetchMultiNumericFeatures',
  async (action: IPaginationRequest, thunkAPI) => {
    return FeatureApi.fetchMultiNumericFeatures(action, thunkAPI.dispatch);
  }
);

//To create an multinumeric feature
export const createMultiNumericFeature = createAsyncThunk(
  'feature/createMultiNumericFeature',
  async (action: IMultiNumericCreateRequest, thunkAPI) => {
    return FeatureApi.createMultiNumericFeature(action, thunkAPI.dispatch);
  }
);

//To Update an existing  multinumeric feature
export const updateMultiNumericFeature = createAsyncThunk(
  'feature/updateMultiNumericFeature',
  async (action: IMultiNumericCreateRequest, thunkAPI) => {
    return FeatureApi.updateMultiNumericFeature(action, thunkAPI.dispatch);
  }
);

//To delete multi numeric features
export const deleteMultiNumericFeatures = createAsyncThunk(
  'feature/deleteMultiNumericFeatures',
  async (action: IDeleteRequest, thunkAPI) => {
    return FeatureApi.deleteMultiNumericFeatures(action, thunkAPI.dispatch);
  }
);

//To fetch single multinumeric features to edit the details
export const fetchMultiNumericFeatureDetails = createAsyncThunk(
  'feature/fetchMultiNumericFeatureDetails',
  async (action: IPaginationRequest, thunkAPI) => {
    return FeatureApi.fetchMultiNumericFeatureDetails(action, thunkAPI.dispatch);
  }
);

const featureSlice = createSlice({
  name: 'feature',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMultiNumericFeatures.fulfilled, (state, action) => {
      if (!('error' in action.payload)) {
        return updateTableData(state.multiNumericFeature, action.payload);
      }
      return state;
    });
  },
});

export default featureSlice.reducer;
